import { useEffect, useState } from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import PaymentForm from "../PaymentForm/PaymentForm";
import "./PaymentStep.css";

const stripePromise = loadStripe(
  "pk_test_51PVblCFhNDvgGzPkFthvBmIwfdJ9qJMZCU9GqCNif2oF6hbTdJVdDBb0Ffmg9Bao1xmbfbYTGBQiO8QRylJ16r8p00zGKb4lPS"
);
// Main component that wraps the form with Elements provider
const PaymentStep = ({ orderData, onBack }) => {
  const [clientSecret, setClientSecret] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    console.log("PaymentStep received orderData:", orderData);

    // Extract client secret from the order data
    const secret = orderData?.stripe_payment_intent_client_secret;

    if (secret) {
      console.log("Client secret found:", secret.substring(0, 20) + "...");
      setClientSecret(secret);
      setLoading(false);
    } else {
      console.error("No client secret found in order data");
      setError("Payment information is missing. Please go back and try again.");
      setLoading(false);
    }
  }, [orderData]);

  if (loading) {
    return (
      <section className="PaymentStep">
        <div style={{ textAlign: "center", padding: "40px 20px" }}>
          <p>Loading payment form...</p>
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section className="PaymentStep">
        <div style={{ textAlign: "center", padding: "40px 20px" }}>
          <p style={{ color: "red", marginBottom: "20px" }}>{error}</p>
          <button
            onClick={onBack}
            style={{
              backgroundColor: "#007cba",
              color: "white",
              padding: "10px 20px",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            Back to Billing
          </button>
        </div>
      </section>
    );
  }

  return (
    <Elements stripe={stripePromise}>
      <PaymentForm
        orderData={orderData}
        onBack={onBack}
        clientSecret={clientSecret}
      />
    </Elements>
  );
};

export default PaymentStep;
